import * as React from 'react';
import styled from '@emotion/styled';
import { GuaranteeIcon } from '../../../components/Icons/newIcons/GuaranteeIcon';
import { __ } from '../../../helpers/TranslationService';

const styles = {
    icon: {
        padding: '3px',
    },
};

const Wrapper = styled.div`
    margin: 15px;
    padding: 10px;
    background-color: ${(props) => props.theme.colors.turtleGreen[4]};
    border: solid 2px;
    border-radius: 6px;
    border-color: ${(props) => props.theme.colors.turtleGreen[20]};
    position: relative;
    text-align: left;
    display: flex;
`;

const HeadingWrapper = styled.div`
    margin-bottom: 8px;
    display: flex;
    align-items: center;
`;

const StyledGiftIcon = styled(GuaranteeIcon)`
    fill: ${(props) => props.theme.colors.turtleGreen[100]};
    margin-right: 7px;
    vertical-align: middle;
`;

const Heading = styled.span`
    font-size: 14px;
    line-height: 1.5;
    margin-right: 10px;
    color: ${(props) => props.theme.colors.gunmetal[100]};
    font-weight: 700;
`;

const Text = styled.span`
    font-size: 14px;
    line-height: 22px;
    color: ${(props) => props.theme.colors.gunmetal[100]};
    margin: 0;
`;

export const CTABanner = (props) => {
    return (
        <Wrapper id="bestPriceBanner" {...props}>
            <HeadingWrapper>
                <div style={styles.icon}>
                    <StyledGiftIcon width={20} height={20} />
                </div>
                <div>
                    <Heading>{__('bpg banner title', 'dreamlines')}</Heading>
                    <Text>{__('bpg banner text', 'dreamlines')}</Text>
                </div>
            </HeadingWrapper>
        </Wrapper>
    );
};
